import AccountService from '@/services/AccountService.js'

export const state = {
  cleaners: [],
  cleaner: {}
}

export const mutations = {
  ADD_CLEANER(state, cleaner) {
    state.cleaners.push(cleaner)
  },
  DELETE_CLEANER(state, cleaner) {
    state.cleaners = state.cleaners.filter(t => t.id != cleaner.id)
  },
  EDIT_CLEANER(state, cleaner) {
    state.cleaner = cleaner
  },
  SET_CLEANERS(state, cleaners) {
    state._cleaners = cleaners
  },
  SET_CLEANER(state, cleaner) {
    state.cleaner = cleaner
  }
}

export const namespaced = true //all mutations, actions, getters will be namespaced under "Product"//

export const actions = {
  fetchCleanerDetails({ commit, dispatch }) {
    return AccountService.getCleaner()
      .then(response => {
        commit('SET_CLEANER', response.data)
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching cleaner: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  fetchCleaner({ commit, getters }, id) {
    var cleaner = getters.getCleanerById(id)

    if (cleaner) {
      commit('SET_CLEANER', cleaner)
      return cleaner
    } else {
      return AccountService.getCleaner(id) // <-- Send the prop id to our ProductService//
        .then(response => {
          commit('SET_CLEANER', response.data)
          return response.data
        })
    }
  },
  removeCleaner({ commit }, cleaner) {
    AccountService.deleteCleaner(cleaner)
    commit('DELETE_CLEANER', cleaner)
  },
  editCleaner({ commit }, cleaner) {
    commit('EDIT_CLEANER', cleaner)
    return AccountService.updateCleaner(cleaner)
  }
}

export const getters = {
  getCleanerById: state => id => {
    return state.cleaner.find(cleaner => cleaner.id === id)
  }
}
